export const isHexColor = (color:string) => /^#(?:[0-9a-fA-F]{3}){1,2}$/.test(color);

const defaultThreshold = 170;

export const isDark = (color: string, threshold = defaultThreshold, defaultDark = false) => {
  if (!isHexColor(color)) {
    return defaultDark;
  }
  let r = parseInt(`${color.slice(1, 2)}${color.slice(1, 2)}`, 16);
  let g = parseInt(`${color.slice(2, 3)}${color.slice(2, 3)}`, 16);
  let b = parseInt(`${color.slice(3, 4)}${color.slice(3, 4)}`, 16);

  if (color.length > 4) {
    r = parseInt(color.slice(1, 3), 16);
    g = parseInt(color.slice(3, 5), 16);
    b = parseInt(color.slice(5, 7), 16);
  }
  return (r * 0.299 + g * 0.587 + b * 0.114) < threshold;
};

export const getContrastColor = (backgroundColor: string, defaultDark = false, dark = '#000', light = '#FFF', threshold = defaultThreshold) => (
  isDark(backgroundColor, threshold, defaultDark) ? light : dark
);
